/**
 * @author wutao
 * @description 考试天天学练报表统计
 * @Date 2022/08/31
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { mapStateToProps, handleExport } from '../../utils';
import { templateConfig, reduxTemplateCofig } from "./config";
import {examEverydayExcelColumns} from './column';
import moment from "moment";

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYYMMDDHHmm') : '';
}
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
class ExamEverydayStatistics extends WizContainer {
  componentName = "ExamEverydayStatistics";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        startDate: formatterDate(val.startDate),
        endDate: formatterDate(val.endDate),
      }))
      const title = '天天学练考试'
      let dateTime = formatterDateTime(new Date());
      WizBrowserExport({
        title,
        sheetName: title,
        columns: examEverydayExcelColumns.filter((_, index) => index),
        rows,
        filename: title +'_' +dateTime+'.xlsx',
      })
      return true
    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile,
        exportExamEverydayRecordReport: handleExport.bind(this, {title: '天天学练考试记录明细', column: []}),
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(mapStateToProps.bind(this, { nameSpace: 'examEveryday', method: 'examEverydayRecordReport' }))(ExamEverydayStatistics);
